import Vue from 'vue'
import axios from 'axios'
import { baseURL } from '../config'
// 配送单预览
export const getCommodityList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 通用修改接口
export const updateColumn = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=updateCommodity&token=" + token, data)
// 删除
export const deleteCommodity = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=deleteCommodity&token=" + token, data)